/*
 * @Description: 服务采购管理
 * @Date: 2025-06-11 19:13:08
 */
import { route } from './src/router';

const name = 'procurement-mgmt';
export { name, route };
